export default __webpack_public_path__ + "static/media/rozbudowa4.457fa39d.svg";